import { Message } from "element-ui";

/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(16);
  });
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 倒计时（比如验证码）
 * @param {*} seconds
 */
export function countDown(seconds) {
  let sec = seconds;
  return cb => {
    // 先触发一遍
    cb(sec);
    // 再执行递归
    recursiveFoo(sec);

    function recursiveFoo(sec) {
      setTimeout(() => {
        cb(sec);
        sec--;
        if (sec >= 0) {
          recursiveFoo(sec);
        }
      }, 1000);
    }
  };
}

/**
 * 将图片转换为 base64
 * @param {String} url
 * @param {*} callback
 * @param {String} outputFormat
 */
export function convertImgToBase64(url, callback, outputFormat) {
  let canvas = document.createElement("CANVAS");
  let ctx = canvas.getContext("2d");
  let img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    let dataURL = canvas.toDataURL(outputFormat || "image/png");
    callback.call(this, dataURL);
    // Clean up
    canvas = null;
  };
  img.src = url;
}

/**
 * 打开新页面
 * @param {String} url 地址
 */
export function open(url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.setAttribute("id", "a-link-temp");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById("a-link-temp"));
}

// 下载文件
export function downloadFile(res) {
  if (res.type === "application/json") {
    const reader = new FileReader();
    reader.readAsText(res); // 読み取り開始
    reader.onload = () => {
      // 读取完成后，将文本还原为JSON对象
      const result = JSON.parse(reader.result);
      Message({
        message: result.msg || "Export failed",
        type: "error",
      });
    };
  } else {
    // 1. 创建Blob对象
    const blob = new Blob([res.data]);
    // 2. 创建隐藏下载链接
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    // 3. 设置下载文件名（可从API的header获取）
    const disposition = res.headers["content-disposition"];
    let fileName = "downloaded-file";
    if (disposition && disposition.includes("filename=")) {
      fileName = decodeURIComponent(disposition.split("filename=")[1]);
    }
    link.setAttribute("download", fileName);
    // 4. 运行下载
    document.body.appendChild(link);
    link.click();
    // 5. 清理临时URL
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
}

// 表单验证快速定位
export function validateLocation(object, that) {
  for (let i in object) {
    let dom = that.$refs[i];
    //这里是针对遍历的情况（多个输入框），取值为数组
    if (Object.prototype.toString.call(dom) !== "[object Object]") {
      dom = dom[0];
    }
    //第一种方法（包含动画效果）
    dom.$el.scrollIntoView({
      //滚动到指定节点
      block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
      behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
    });
    break;
  }
}

// 表单校验失败时，基于 el-form 实例的 fields 定位到第一个失败字段
// 与 validateLocation 的区别：formRef.fields 仅含"当前表单"的字段，
// 可规避多 tab / 多表单下同名 $refs 冲突导致的定位错乱
export function validateFormLocation(object, formRef) {
  if (!object || !formRef || !formRef.fields) return;
  const failedKeys = Object.keys(object);
  const failedField = formRef.fields.find(f => failedKeys.includes(f.prop));
  if (failedField && failedField.$el) {
    failedField.$el.scrollIntoView({
      block: "center", // 滚动到视图区域中间
      behavior: "smooth", // 缓动动画
    });
  }
}

// 检查是否为数字或数字字符串
export function isNumberLike(val) {
  // 排除 null, undefined, boolean, Symbol 等非目标类型
  if (val === null || val === undefined || typeof val === "boolean" || typeof val === "symbol") {
    return false;
  }
  // 排除数组和对象（防止 [123] 被误判）
  if (typeof val === "object") return false;
  // 排除空字符串或全是空格的字符串
  if (typeof val === "string" && val.trim() === "") return false;
  // 利用 Number() 的严格转换特性
  // Number() 转换 "12px" 会得到 NaN，而parseFloat会得到12
  const n = Number(val);
  return !isNaN(n) && isFinite(n);
}

// 从数据源中获取表单需要的数据
export function getFormDataFromSource(dataSource, dataForm) {
  // 定义不想被覆盖的“黑名单”字段
  const ignoreFields = ["id"];
  // 浅拷贝原表单，保留初始状态（包括原有的id等）
  const source = dataSource;
  const newDataForm = { ...dataForm };
  // 只挑选dataForm已有的属性进行copy
  Object.keys(newDataForm).forEach(key => {
    // 逻辑：既不在黑名单中，且源数据中确实存在该属性
    if (!ignoreFields.includes(key) && key in source) {
      newDataForm[key] = source[key];
    }
  });
  return newDataForm;
}

// 将base64编码转换为File对象
export function base64ToFile(base64, fileName = "image.png") {
  const byteString = atob(base64);

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, {
    type: "image/png",
  });
}
